import React, { Component } from 'react'
import styled from 'styled-components'
import { Container, Row, Col, media } from 'styled-bootstrap-grid'
import theme from 'ui/styles/theme'

const Wrapper = styled.div`
  padding: 50px 0;
  margin-bottom: 75px;
`

const Text = styled.div`
  font-weight: 300;
`

const BlockQuote = Text.withComponent('blockquote').extend`
  border: 0;
  font-size: 30px;
  line-height: 40px;
  margin: 0 0 40px;
  padding: 0;

  p {
    margin-bottom: 0;
  }

  ${media.xs`
    font-size: 18px;
    line-height: 25px;
  `}
`

const Person = styled.div`
  border-top: 1px solid ${theme.colors.tones.darker};
`

const Name = Text.extend`
  color: ${theme.colors.tones.darker};
  font-size: 20px;
  font-weight: 400;
  line-height: 22px;
  margin-top: 22px;

  ${media.xs`
    font-size: 18px;
    line-height: 22px;
  `}
`

const Company = Text.extend`
  color: ${theme.colors.secondary};
  font-size: 12px;
  font-weight: 500;
  line-height: 22px;
  text-transform: uppercase;

  ${media.xs`
    font-size: 10px;
  `}
`

class Quote extends Component {
  render() {
    const { quote, name, company } = this.props
    
    return (
      <Wrapper>
        <Container fluid>
          <Row>
            <Col
              sm={9}
              smOffset={3}
            >
              <BlockQuote dangerouslySetInnerHTML={{ __html: quote }} />
            </Col>
            <Col sm={3} smOffset={5}>
              <Person>
                <Name>{name}</Name>
                <Company>{company}</Company>
              </Person>
            </Col>
          </Row>
        </Container>
      </Wrapper>
    )
  }
}

export default Quote



// WEBPACK FOOTER //
// ./src/ui/components/modules/Quote/index.js